var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    { attrs: { "no-sidebar": true, "no-box": true, title: "Parking OTA" } },
    [
      _vm.allowed
        ? _c("div", { staticClass: "parking-ota" }, [
            _c("section", { staticClass: "parking-ota__card" }, [
              _c("div", { staticClass: "parking-ota__card-head" }, [
                _c("h2", [_vm._v("Parking parameters")]),
                _vm._v(" "),
                _c("p", { staticClass: "parking-ota__sub" }, [
                  _vm._v("All fields are sent to the affiliate widget on load.")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "parking-ota__card-body" }, [
                _c("div", { staticClass: "parking-ota__grid" }, [
                  _c("div", { staticClass: "parking-ota__field" }, [
                    _c("label", { attrs: { for: "inputChannelId" } }, [
                      _vm._v("Channel ID")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.channelId,
                          expression: "form.channelId"
                        }
                      ],
                      attrs: { type: "number", id: "inputChannelId", min: "1" },
                      domProps: { value: _vm.form.channelId },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "channelId", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "parking-ota__field" }, [
                    _c("label", { attrs: { for: "inputAirportCode" } }, [
                      _vm._v("Airport code")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.airportCode,
                          expression: "form.airportCode"
                        }
                      ],
                      attrs: {
                        type: "text",
                        id: "inputAirportCode",
                        placeholder: "e.g. ATL"
                      },
                      domProps: { value: _vm.form.airportCode },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "airportCode", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "parking-ota__field" }, [
                    _c("label", { attrs: { for: "inputFromDate" } }, [
                      _vm._v("From "),
                      _c("span", { staticClass: "parking-ota__hint" }, [
                        _vm._v("(YYYY-MM-DD HH:mm:ss)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.fromDate,
                          expression: "form.fromDate"
                        }
                      ],
                      attrs: { type: "text", id: "inputFromDate" },
                      domProps: { value: _vm.form.fromDate },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "fromDate", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "parking-ota__field" }, [
                    _c("label", { attrs: { for: "inputToDate" } }, [
                      _vm._v("To "),
                      _c("span", { staticClass: "parking-ota__hint" }, [
                        _vm._v("(YYYY-MM-DD HH:mm:ss)")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.toDate,
                          expression: "form.toDate"
                        }
                      ],
                      attrs: { type: "text", id: "inputToDate" },
                      domProps: { value: _vm.form.toDate },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.form, "toDate", $event.target.value)
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "parking-ota__field parking-ota__full" },
                    [
                      _c("label", { attrs: { for: "inputUserEmail" } }, [
                        _vm._v("User email")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.userEmail,
                            expression: "form.userEmail"
                          }
                        ],
                        attrs: {
                          type: "email",
                          id: "inputUserEmail",
                          autocomplete: "email"
                        },
                        domProps: { value: _vm.form.userEmail },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "userEmail", $event.target.value)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "parking-ota__field parking-ota__full" },
                    [
                      _c("label", { attrs: { for: "inputUserName" } }, [
                        _vm._v("User name")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.userName,
                            expression: "form.userName"
                          }
                        ],
                        attrs: {
                          type: "text",
                          id: "inputUserName",
                          autocomplete: "name"
                        },
                        domProps: { value: _vm.form.userName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "userName", $event.target.value)
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "parking-ota__field parking-ota__full" },
                    [
                      _c("label", { attrs: { for: "inputPhoneNumber" } }, [
                        _vm._v("Phone number")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.phoneNumber,
                            expression: "form.phoneNumber"
                          }
                        ],
                        attrs: { type: "text", id: "inputPhoneNumber" },
                        domProps: { value: _vm.form.phoneNumber },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.form,
                              "phoneNumber",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "parking-ota__actions" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", disabled: !_vm.scriptLoaded },
                  on: { click: _vm.loadIframe }
                },
                [_vm._v("Load parking iframe")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button", disabled: !_vm.scriptLoaded },
                  on: { click: _vm.removeIframe }
                },
                [_vm._v("Remove iframe")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "parking-ota__preview" }, [
              _c("span", { staticClass: "parking-ota__preview-label" }, [
                _vm._v("Widget preview")
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "reslabIframe", role: "region" } })
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29b3904b", { render: render, staticRenderFns: staticRenderFns })
  }
}